import { socket } from "../socket";

export const fetchPendingInvoicesCount = ({ token, productId, workspaceId, lang = "en" }) => {
    if (!token || !productId) return Promise.resolve(0);

    return new Promise((resolve) => {
        const requestId = `invoices:counters-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const responseEvent = "invoices:counters-response";

        const cleanup = () => socket.off(responseEvent, handler);

        const handler = (payload = {}) => {
            if (payload.request_id !== requestId) return;
            cleanup();
            if (payload.status === 1) {
                const count = payload.pending_count ?? payload.data?.pending_count ?? 0;
                resolve(Number.isFinite(count) ? count : 0);
            } else {
                resolve(0);
            }
        };

        socket.on(responseEvent, handler);
        socket.emit("invoices:counters", {
            request_id: requestId,
            token,
            product_id: productId,
            workspace_id: workspaceId,
            lang,
        });

        setTimeout(() => {
            cleanup();
            resolve(0);
        }, 10000);
    });
};
